export default "__VITE_ASSET__DFCrIPG___"